import React from 'react'
import './index.scss'
import { useBreakpointContext } from '../../util/BreakpointProvider'

export function Intro({ content }) {
  const { isMobile, isTablet } = useBreakpointContext();

  const handleScroll = (e) => {
    e.preventDefault();
    const element = document.getElementById('explore-data');
    if (element) {
      const headerOffset = isMobile || isTablet ? 62 : 88;
      window.scrollTo({
        top: element.offsetTop - headerOffset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className='maps inset padded no-border'>
      <div className='vstack narrow'>
        <div>
          <h2 className="center">{content.intro.text1}</h2>
        </div>

      <div className="padded flex">
        <div className='skinny dashed-border explore-data-link'>
          <a href="#explore-data" className="center no-underline" style={{ textDecoration: 'none' }} onClick={handleScroll}>
            <span>Jump to the data</span>
            <img src="assets/expeditionspage/arrow-right.svg" alt="arrow right" />
          </a>
        </div>

      </div>

        <div className='image'>
          <img src={`assets/expeditionspage/map1.png`} alt='Expedition 1' />
        </div>

        <div className='divider' />

        <p className='center skinny'>{content.intro.text2}</p>

        <div className='image'>
          <img src={`assets/expeditionspage/map2.png`} alt='Expedition 1' />
        </div>
      </div>
    </section>
  )
} 